import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { updateTheme } from "../../store/themeSlice";

import "./index.css";

const Navbar = () => {
  const theme = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navWebClass = theme === "LIGHT" ? "nav-light" : "nav-dark";
  const navMobileClass = theme === "DARK" ? "nav-light" : "nav-dark";

  const navbarWeb = () => (
    <nav className={`nav-container nav-web ${navWebClass}`}>
      <h1 className="nav-logo">OMK</h1>
      <ul className="link-tabs-container link-tabs-container-lg">
        <Link to="/">
          <li>Home</li>
        </Link>
        <Link to="/about">
          <li>About</li>
        </Link>
        <Link to="/work">
          <li>Work</li>
        </Link>
        <Link to="/techstack">
          <li>Skills</li>
        </Link>
        <Link to="/contact">
          <li>Contact</li>
        </Link>
      </ul>
      <div className="link-tabs-container link-tabs-container-lg">
        <button type="button" className="social-button">
          <a href="https://www.linkedin.com/in/omkumbhare" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Group_dra5tf.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447267/Portfolio%20App/Group_jvo36a.png"
              }
              alt="linkedIn"
            />
          </a>
        </button>
        <button type="button" className="social-button">
          <a href="https://twitter.com/omkumbhare" target="blank">
            <img
              style={{
                backgroundColor: theme === "LIGHT" ? "transparent" : "#f6f6f6",
                borderRadius: theme === "LIGHT" ? "0" : "5px",
              }}
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
              }
              alt="x"
            />
          </a>
        </button>
        <button type="button" className="social-button">
          <a href="https://github.com/DEV-OMK" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696446757/Portfolio%20App/github-mark_1_mzi8tn.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696485284/Portfolio%20App/github-mark-white_1_xou4t4.png"
              }
              alt="github"
            />
          </a>
        </button>
        <button
          type="button"
          className="social-button"
          onClick={() => {
            theme === "LIGHT"
              ? dispatch(updateTheme("DARK"))
              : dispatch(updateTheme("LIGHT"));
          }}
        >
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696488675/Portfolio%20App/Group_puymbc.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447208/Portfolio%20App/Group_errbxw.png"
            }
            alt="theme"
          />
        </button>
      </div>
    </nav>
  );

  const navbarMobile = () => (
    <nav className={`nav-container nav-mobile ${navMobileClass}`}>
      <Link to="/">
        <button type="button" className="social-button">
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Home_-_Fill_ehuy19.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447566/Portfolio%20App/Home_-_Outline_map6cr.png"
            }
            alt="home"
          />
        </button>
      </Link>
      <Link to="/about">
        <button type="button" className="social-button">
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/User_-_Fill_uvlygi.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/User_-_Outline_jgqcag.png"
            }
            alt="about"
          />
        </button>
      </Link>
      <Link to="/work">
        <button type="button" className="social-button">
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447576/Portfolio%20App/Bag_-_Fill_fvafxw.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447578/Portfolio%20App/Bag_-_Outline_jgbi2f.png"
            }
            alt="work"
          />
        </button>
      </Link>
      <Link to="/techstack">
        <button type="button" className="social-button">
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/Stack_-_Fill_xzeewe.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/Stack_-_Outline_qjbibv.png"
            }
            alt="skills"
          />
        </button>
      </Link>
      <Link to="/contact">
        <button type="button" className="social-button">
          <img
            src={
              theme === "LIGHT"
                ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447577/Portfolio%20App/Message_-_Fill_ukthre.png"
                : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696444346/Portfolio%20App/Frame_i9yxuh.png"
            }
            alt="contact"
          />
        </button>
      </Link>
      <button
        type="button"
        className="social-button"
        onClick={() => {
          theme === "LIGHT"
            ? dispatch(updateTheme("DARK"))
            : dispatch(updateTheme("LIGHT"));
        }}
      >
        <img
          src={
            theme === "LIGHT"
              ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696488675/Portfolio%20App/Group_puymbc.png"
              : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447208/Portfolio%20App/Group_errbxw.png"
          }
          alt="theme"
        />
      </button>

      <div className="link-tabs-container link-tabs-container-lg">
        <button type="button" className="social-button">
          <a href="https://www.linkedin.com/in/omkumbhare" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Group_dra5tf.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447267/Portfolio%20App/Group_jvo36a.png"
              }
              alt="linkedIn"
            />
          </a>
        </button>
        <button type="button" className="social-button">
          <a href="https://twitter.com/omkumbhare" target="blank">
            <img
              style={{
                backgroundColor: theme === "LIGHT" ? "transparent" : "#f6f6f6",
                borderRadius: theme === "LIGHT" ? "0" : "5px",
              }}
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
              }
              alt="x"
            />
          </a>
        </button>
        <button type="button" className="social-button">
          <a href="https://github.com/DEV-OMK" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696446757/Portfolio%20App/github-mark_1_mzi8tn.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696485284/Portfolio%20App/github-mark-white_1_xou4t4.png"
              }
              alt="github"
            />
          </a>
        </button>
      </div>
    </nav>
  );

  return (
    <>
      {navbarWeb()}
      {navbarMobile()}
    </>
  );
};

export default Navbar;
